/**
 * Base configuration shared across all environments and variants
 * Contains only common settings used by both DOE and OCW configs
 */
export const BASE_CONFIG = {
  /** Common authentication scopes */
  commonScopes: 'openid profile offline_access doorstroomtoets-api.fullaccess',

  /** Common Application Insights instrumentation key */
  applicationInsightsKey: 'cc4475b3-2100-4048-8626-42b7b376576c',

  /** Replaced by Azure DevOps during CI builds */
  primeNGLicenseToken: 'eyJpZCI6Ijk4NjE3M2JhLTQ3NGYtNDJlMC04ODRiLWEzZWYwODI5ZGZhNCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzkyMDc4MjI0LCJleHAiOjE4MjM1NDc2MDB9.arXVaAS4RYr2i9Owj3GMGxfNjR1FDOnxcEvMjcbCWkv0erXw3zY2OsxuaQ9eGxPKkluYx1lONTItcHHA5n6PBw',
};
